import React from 'react';

interface ArrowIconProps {
  className?: string;
}

function ArrowIcon({ className }: ArrowIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" className={className}>
      <path fill="currentColor" d="M12 5l-4.947 5-.99-1 3.258-3.293H0V4.293h9.32L6.064 1l.99-1z"></path>
    </svg>
  );
}

export default ArrowIcon;
